import { get, set } from 'lodash'

export const initializeFormFields = (props, fields) => {
  const currentFormValues = get(props, 'values', {})

  const initData = { ...currentFormValues }

  // Populate initData with values from the fields array
  fields.forEach(field => {
    if (field.value) {
      set(initData, field.name, field.value)
    }
  })

  // Initialize the form with the collected data
  props.initialize({ ...initData })

  // Trigger onChange of each field
  fields.forEach(field => {
    if (field.value) {
      props.change(field.name, field.value)
    }
  })
}
